import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import Toastify from "../Universal/Toastify";

const SessionExpired = () => {
  const navigate = useNavigate();
  const { logout } = useAuth0();
  const logoutUser = () => {
    console.log("Logged out");
    localStorage.clear();
    logout({ returnTo: window.location.origin });
  };
  useEffect(() => {
    logoutUser();
    Toastify("Session Expired. Login Required!");
    navigate("/login");
  }, []);
};

export default SessionExpired;
